"use client";

import { CONFIG } from "@/utils/config";
import { GoogleOAuthProvider } from "@react-oauth/google";
import React, { createContext, useContext } from "react";

interface GoogleAuthProviderProps {
  children: React.ReactNode;
}

interface GoogleAuthContextValues {
  isAvailable: boolean;
}

const GoogleAuthContext = createContext<GoogleAuthContextValues>({
  isAvailable: false,
});

export const useGoogleAuth = () => useContext(GoogleAuthContext);

export function GoogleAuthProvider({ children }: GoogleAuthProviderProps) {
  const googleClientId = CONFIG.googleClientId;
  // Always provide the context, but only wrap with GoogleOAuthProvider when ready
  if (!googleClientId) {
    return (
      <GoogleAuthContext.Provider value={{ isAvailable: googleClientId != null }}>
        {children}
      </GoogleAuthContext.Provider>
    );
  }

  return (
    <GoogleAuthContext.Provider value={{ isAvailable: true }}>
      <GoogleOAuthProvider clientId={googleClientId}>
        {children}
      </GoogleOAuthProvider>
    </GoogleAuthContext.Provider>
  );
}
